import React, { useState } from "react";
import { Mail } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { KIND_LABELS } from "@/lib/marketing";

export const EmailPrefs = ({ prefs, onChange }) => {
  const [saving, setSaving] = useState(false);

  const save = async (next) => {
    setSaving(true);
    try {
      const r = await api.put("/agent/marketing/preferences", next);
      onChange(r.data);
      toast.success("Preferenze aggiornate");
    } catch {
      toast.error("Aggiornamento non riuscito");
    } finally {
      setSaving(false);
    }
  };

  const off = prefs.unsubscribed;
  return (
    <div id="preferenze" className="vg-card p-5" data-testid="marketing-email-prefs">
      <div className="flex items-center gap-2 mb-1 text-[#B40101]"><Mail size={16} /><h3 className="font-bold text-[#0A0A0A]">Avvisi email</h3></div>
      <p className="text-xs text-gray-500 mb-4">Ti scriviamo solo quando pubblichiamo nuovi materiali.</p>
      <div className="space-y-2">
        {Object.keys(KIND_LABELS).map((k) => (
          <label key={k} className={`flex items-center gap-2 text-sm ${off ? "text-gray-300" : "text-gray-700"}`}>
            <input
              type="checkbox" disabled={off || saving} checked={!off && prefs.kinds[k]}
              onChange={(e) => save({ kinds: { ...prefs.kinds, [k]: e.target.checked }, unsubscribed: false })}
              data-testid={`pref-${k}`}
            />
            {KIND_LABELS[k]}
          </label>
        ))}
      </div>
      <button
        disabled={saving}
        onClick={() => save({ kinds: prefs.kinds, unsubscribed: !off })}
        className="mt-4 text-xs font-semibold underline text-gray-500 hover:text-[#B40101] transition-colors"
        data-testid="pref-toggle-unsubscribe"
      >
        {off ? "Riattiva gli avvisi email" : "Disattiva tutti gli avvisi email"}
      </button>
      {off && <p className="text-xs text-[#B40101] mt-2" data-testid="pref-unsubscribed-note">Avvisi email disattivati.</p>}
    </div>
  );
};
